import styled from "styled-components";
import { colorsPalettes, mixins, fonts, rgba } from "@similarweb/styles";
import { ChipItemText, Tab } from "@similarweb/ui-components";
import { SimpleChipItem } from "@similarweb/ui-components";
import { BooleanSearchWrap, BooleanSearchInputWrap, BooleanSearchInput } from "@similarweb/ui-components";
import { DotsLoader } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import type { ICompleteRuleChipItem } from "app/pages/segments/redesigned-wizard/segment-wizard/types";
import { ScrollArea } from "@similarweb/ui-components";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { SegmentUrlListItemContainer } from "app/pages/segments/redesigned-wizard/segment-wizard/segments-url-list/SegmentUrlListStyles";
import type { IScrollAreaProps } from "@similarweb/ui-components";
import type { FC } from "react";
import { SWReactIcons } from "@similarweb/icons";

export const DEFAULT_CHIPS_CONTAINER_HEIGHT = 264;

const dropdownBorderStyle = `8px solid ${colorsPalettes.carbon[25]};`;

export const PagesWrapperContainer = styled.div<{ isExclude: boolean }>`
    ${({ isExclude }) => (isExclude ? "margin-bottom: 80px;" : "")};
    border: 1px solid ${colorsPalettes.navigation.BORDER_DARK_1};
    box-sizing: border-box;
    border-radius: 4px;
    margin-left: 24px;
    margin-right: 24px;
    padding-bottom: 16px;
    .DropdownContent-container {
        padding-top: 0px;
    }
`;
PagesWrapperContainer.displayName = "PagesWrapperContainer";

export const PagesTitle = styled.div`
    font-size: 16px;
    font-weight: 500;
    font-family: ${fonts.$dmSansFontFamily};
    margin-top: 16px;
    margin-left: 16px;
    margin-bottom: 12px;
    height: 24px;
    line-height: 24px;
    color: ${colorsPalettes.carbon["400"]};
    white-space: nowrap;
`;
PagesTitle.displayName = "PagesTitle";

export const AddFilterButtonWrapper = styled.div<{ isSelectedValue: boolean }>`
    ${({ isSelectedValue }) =>
        isSelectedValue
            ? "pointer-events: none; cursor: default; margin: 8px 0 8px 8px;"
            : "pointer-events: all; cursor: pointer;"};
    align-self: center;
    .DropdownButton .DropdownButton-text {
        width: 100%;
    }
`;
AddFilterButtonWrapper.displayName = "AddFilterButtonWrapper";

export const TooltipWrapper = styled.div<{
    isSelectedValue?: boolean;
    isLocked?: boolean;
    disabledItemColor?: boolean;
}>`
    width: 100%;
    display: flex;
    ${({ disabledItemColor }) => (disabledItemColor ? "opacity: 0.4; cursor: default" : "")};
    > div:first-child {
        width: 100%;
        path {
            fill: ${({ isLocked }) => (isLocked ? colorsPalettes.mint["400"] : colorsPalettes.carbon["200"])};
        }
    }
    > div > div > div {
        ${({ isSelectedValue }) => (isSelectedValue ? "padding-left: 0px;" : "")};
        height: ${({ isSelectedValue }) => (isSelectedValue ? "37px" : "44px")};
    }
`;
TooltipWrapper.displayName = "TooltipWrapper";

export const ListItemKeywordWrapper = styled.div<{
    isSelectedValue?: boolean;
}>`
    display: flex;
    width: 100%;
    ${({ isSelectedValue }) => (isSelectedValue ? "pointer-events: none;" : "")};
`;
ListItemKeywordWrapper.displayName = "ListItemKeywordWrapper";

export const TabListWrapper = styled.div`
    display: flex;
    height: 46px;
    > ul {
        height: 46px;
    }
    border-bottom: 1px solid ${colorsPalettes.navigation.BORDER_DARK_2};
`;
TabListWrapper.displayName = "TabListWrapper";

export const StyledTab = styled(Tab)`
    width: 160px;
`;
StyledTab.displayName = "StyledTab";

export const DropdownIconWrapper = styled.div<{ isLocked?: boolean }>`
    margin: -2px 8px 0 0;
    path {
        fill: ${({ isLocked }) => (isLocked ? colorsPalettes.mint[400] : colorsPalettes.blue[400])};
    }
`;
DropdownIconWrapper.displayName = "DropdownIconWrapper";

export const CircleIndicator = styled.div<{ isInclude: boolean }>`
    background-color: ${({ isInclude }) => (isInclude ? colorsPalettes.mint[400] : colorsPalettes.red[400])};
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-top: 25px;
    margin-left: 4px;
`;
CircleIndicator.displayName = "CircleIndicator";

export const DropdownContainer = styled.div<{
    isSelectedValue: boolean;
    displayTopMargin: boolean;
}>`
    margin-top: 8px;
    &:first-child {
        margin-top: ${({ displayTopMargin }) => (displayTopMargin ? "8px" : "0")};
    }
    ${({ isSelectedValue }) => (isSelectedValue ? `background-color: ${colorsPalettes.carbon[25]};` : "")};
    position: relative;
    display: flex;
    .DropdownButton {
        background: ${colorsPalettes.carbon["0"]};
    }
    .DropdownButton-text {
        color: ${colorsPalettes.carbon["400"]};
    }
`;
DropdownContainer.displayName = "DropdownContainer";

export const ActiveFilterComponentWrapper = styled.div<{
    isSelectedValue: boolean;
    isActiveFilterComponent: boolean;
}>`
    margin: ${({ isActiveFilterComponent }) => (isActiveFilterComponent ? "0 0 16px 0" : "0 16px 12px;")};
    &:last-child {
        margin-bottom: 0;
    }
    &:not(:nth-last-child(-n + 3)) {
        margin-bottom: ${({ isActiveFilterComponent }) => (isActiveFilterComponent ? "16px;" : "4px;")};
    }
    ${({ isSelectedValue }) =>
        isSelectedValue ? `border-left: ${dropdownBorderStyle}; border-right: ${dropdownBorderStyle};` : ""};
`;
ActiveFilterComponentWrapper.displayName = "ActiveFilterComponentWrapper";

export const CheckBoxContainer = styled.div`
    padding: 8px 0px;
    .folders {
        align-items: flex-start;
        label {
            font-size: 12px;
            overflow: hidden;
            word-break: break-all;
            align-self: center;
        }
    }
`;
CheckBoxContainer.displayName = "CheckBoxContainer";

export const BooleanSearchWrapStyled = styled(BooleanSearchWrap)<{
    marginRight?: string;
    showBorderBottom?: boolean;
}>`
    ${({ showBorderBottom }) => (showBorderBottom ? `border-bottom: 1px ${colorsPalettes.blue[400]} solid` : "")};
    padding: 4px 0;
    min-height: 40px;
    margin-right: 10px;
    margin-left: 10px;
    flex: auto;

    ${BooleanSearchInputWrap} {
        position: relative;
        margin-left: 8px;
        margin-right: ${({ marginRight }) => (marginRight ? marginRight : "8px")};
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        ${BooleanSearchInput} {
            box-sizing: border-box;
            flex-grow: 1;
            flex-shrink: 0;
            flex-basis: 280px;
            width: initial;
        }
    }
`;
BooleanSearchWrapStyled.displayName = "BooleanSearchWrapStyled";

export const CustomStringsChipsRowContainer = styled.div<{ isFilterMode: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: -10px;
    padding: ${({ isFilterMode }) => (isFilterMode ? "0 14px 0 16px" : "0 16px")};
    height: 60px;
`;
CustomStringsChipsRowContainer.displayName = "CustomStringsChipsRowContainer";

export const FooterButton = styled.div<{ isEnabled: boolean }>`
    height: 40px;
    width: 100%;
    background-color: ${({ isEnabled }) => (isEnabled ? colorsPalettes.blue[400] : colorsPalettes.carbon[100])};
    display: flex;
    flex-direction: row-reverse;
    padding-right: 16px;
    align-items: center;
    ${mixins.setFontVariant("tab", colorsPalettes.carbon[0])};
    box-sizing: border-box;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    opacity: 1;
    ${({ isEnabled }) =>
        isEnabled ? "pointer-events: all; cursor: pointer;" : "pointer-events: none; cursor: default;"};
`;
FooterButton.displayName = "FooterButton";

export const CompleteRuleChipItem = styled(SimpleChipItem)<ICompleteRuleChipItem>`
    background-color: ${rgba(colorsPalettes.carbon[500], 0.8)};

    ${ChipItemText} {
        color: ${colorsPalettes.carbon[0]};
    }

    &:hover {
        background-color: ${colorsPalettes.carbon[500]};
        ${ChipItemText} {
            color: ${colorsPalettes.carbon[0]};
        }
        ${SWReactIcons} svg path {
            fill: ${colorsPalettes.carbon[0]};
        }
    }

    ${SWReactIcons} {
        margin-right: 9px;
        svg {
            ${({ actionIconName }) => (actionIconName ? "width: 16px; height: 16px;" : "")};
            path {
                fill: ${colorsPalettes.carbon[0]};
                ${({ actionIconName }) => (actionIconName ? "fill-opacity: unset;" : "")};
            }
        }
    }
`;
CompleteRuleChipItem.displayName = "CompleteRuleChipItem";

export const TrashIconWrapper = styled.span`
    cursor: pointer;
    position: absolute;
    right: 18px;
    top: 18px;
    margin-left: 10px;
`;
TrashIconWrapper.displayName = "TrashIconWrapper";

export const CustomStringsChipsContainer = styled.div`
    flex: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height: 40px;
    overflow: hidden;
`;
CustomStringsChipsContainer.displayName = "CustomStringsChipsContainer";

export const CustomStringsViewAllChipsLink = styled.a`
    cursor: pointer;
    font-size: 14px;
    line-height: 18px;
    font-weight: 700;
    white-space: nowrap;
    padding: 10px;
    &:hover {
        background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};
        border-radius: 69px;
        align-items: center;
    }
`;
CustomStringsViewAllChipsLink.displayName = "CustomStringsViewAllChipsLink";

export const BooleanSearchContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const ImportFileLink = styled(IconButton)`
    margin-right: 16px;
    .SWReactIcons {
        width: 1.2em;
        height: 1.2em;
        margin-right: 0.5em;
        transform: rotate(180deg);
    }
`;

export const InlineInputSection = styled.div`
    position: absolute;
    top: 0;
    height: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    margin-left: 16px;

    .inlineButton {
        height: 100%;
        min-width: auto;
    }

    ${DotsLoader} {
        margin-left: 40px;
    }
`;

export const SpanInputMeasure = styled.span`
    font-size: 14px;
    visibility: hidden;
    position: absolute;
    white-space: pre;
`;

export const TabInnerContentContainer = styled(FlexColumn)`
    padding: 0;
    position: relative;
`;

export const ScrollAreaWrapper: FC<IScrollAreaProps> = (props) => (
    <ScrollArea
        style={{
            height: DEFAULT_CHIPS_CONTAINER_HEIGHT,
            zIndex: 99,
            padding: "0 10px 0",
            marginTop: "22px",
        }}
        verticalScrollbarStyle={{ borderRadius: 8, width: 5 }}
        verticalContainerStyle={{ width: 5 }}
        minScrollSize={48}
        {...props}
    >
        {props.children}
    </ScrollArea>
);

export const ChipPlaceholderLoaderWrapper = styled.span`
    border-radius: 16px;
    border-width: 0;
    padding: 0;
    display: inline-block;
    height: 32px;
    overflow: hidden;
    margin: 0 16px 16px 0;
    z-index: 999999;
    box-sizing: border-box;

    & > svg {
        box-sizing: border-box;
    }
`;

export const LoadersWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    height: 144px;
`; // The specific height is so we always show three rows of loaders

export const NoDataContainer = styled.div`
    padding: 20px;
    font-size: 16px;
`;

export const TextAlign = styled.div`
    text-align: center;
    margin-bottom: 8px;
`;

const FilterTypeSeparatorText = styled.span`
    color: ${colorsPalettes.carbon[300]};
    text-transform: lowercase;
    &:first-letter {
        text-transform: uppercase;
    }
    line-height: 16px;
    border-radius: 4px;
    background-color: ${colorsPalettes.carbon[0]};
    position: absolute;
    z-index: 10;
`;
FilterTypeSeparatorText.displayName = "FilterTypeSeparatorText";

export const OrSeparatorText = styled(FilterTypeSeparatorText)`
    margin-top: -8px;
    margin-left: 16px;
`;
OrSeparatorText.displayName = "OrSeparatorText";

export const AndSeparatorText = styled(FilterTypeSeparatorText)`
    margin-left: -28px;
    margin-top: 8px;
`;
AndSeparatorText.displayName = "AndSeparatorText";

export const GroupTitle = styled.div`
    color: ${colorsPalettes.carbon[500]};
    font-family: ${fonts.$dmSansFontFamily};
    line-height: 16px;
    font-size: 14px;
`;
GroupTitle.displayName = "GroupTitle";

export const SegmentRuleWrapper = styled.div<{
    displayBorder?: boolean;
    ruleIndex: number;
    isEmptyRule: boolean;
}>`
    padding: 8px 8px 3px;
    ${({ ruleIndex }) => (ruleIndex === 0 ? "padding-top: 0;" : "")};
    margin: ${({ displayBorder, ruleIndex }) =>
        displayBorder
            ? `0 7px 4px ${ruleIndex * 24 + 7}px`
            : `${ruleIndex === 0 ? 0 : 8}px 8px 8px ${ruleIndex * 24 + 8}px`};
    ${({ ruleIndex }) => (ruleIndex > 0 ? "margin-top: -30px;" : "")};
    ${({ isEmptyRule }) => (isEmptyRule ? "margin-bottom: 0;  padding-bottom: 0;" : "padding-bottom: 16px;")};
    ${({ displayBorder }) =>
        displayBorder ? `border: 1px solid ${colorsPalettes.navigation.BORDER_DARK_1}; padding-top: 12px;` : ""};
    &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
    }
`;
SegmentRuleWrapper.displayName = "SegmentRuleWrapper";

export const GroupConnectorWrapper = styled.span<{
    ruleIndex: number;
}>`
    margin: ${({ ruleIndex }) => `0 0 0 ${ruleIndex * 24 + 16}px`};
`;
GroupConnectorWrapper.displayName = "GroupConnectorWrapper";

export const GroupConnectorHorizontalExtension = styled.div<{
    ruleIndex: number;
}>`
    margin: ${({ ruleIndex }) => `-2px 0 0 ${ruleIndex * 24 + 28}px`};
    height: 2px;
    width: 4px;
    background: ${colorsPalettes.midnight[50]};
`;
GroupConnectorHorizontalExtension.displayName = "GroupConnectorHorizontalExtension";

export const TabMessageContainer = styled.div`
    font-size: 16px;
    color: ${colorsPalettes.carbon["500"]};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
`;

export const TabUrlListContainer = styled.div`
    flex: auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: ${DEFAULT_CHIPS_CONTAINER_HEIGHT}px;

    .ScrollArea {
        padding: 0 !important;
    }

    ${SegmentUrlListItemContainer} {
        padding: 8px 16px;
        font-size: 12px;
        line-height: 14px;
        border-top: 1px solid ${colorsPalettes.bluegrey[200]};
    }
`;

export const ClearFilterWrapper = styled.span`
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    padding: 8px;
    margin-left: 10px;
    &:hover {
        background-color: ${rgba(colorsPalettes.carbon[200], 0.2)};
        border-radius: 69px;
        align-items: center;
    }
`;
ClearFilterWrapper.displayName = "ClearFilterWrapper";

export const AllPagesWrapper = styled.div`
    background-color: ${colorsPalettes.carbon[25]};
    padding: 0 16px 0 8px;
    height: 60px;
    align-items: center;
    flex: auto;
    display: flex;
    margin-bottom: 12px;
`;
AllPagesWrapper.displayName = "AllPagesWrapper";

export const DropdownRemoveFiltersNote = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    ${mixins.setFontVariant("body2", colorsPalettes.carbon["400"])};
    background-color: rgba(62, 116, 254, 0.1);
    border: 1px solid ${colorsPalettes.blue["300"]};
    border-radius: 4px;
    margin: 16px 16px 8px;
    padding: 15px;
`;
DropdownRemoveFiltersNote.displayName = "DropdownRemoveFiltersNote";

export const ListItemKeywordWrapperStyled = styled.div<{ isLocked?: boolean }>`
    span {
        color: ${({ isLocked }) => (isLocked ? colorsPalettes.carbon["250"] : colorsPalettes.carbon["500"])};
    }
`;

export const HiddenPIIUrlsTextContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 447px;
    align-self: center;
    height: 110px;
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["300"])};
`;

export const OrLogicSeparator = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    ${mixins.setFontVariant("body2", colorsPalettes.carbon["300"])};
    margin-right: 5px;
`;
